// import { Button, Modal, Tag, Typography } from "antd";
// import { TbCheck, TbLoader2, TbShieldCheck, TbSparkles, TbX } from "react-icons/tb";
// import type { AuditResult, AuditRule, FixResult } from "hooks/useEmailAudit";
// import { PolicySeverity } from "dtos/smart-negotiation.dto";

// const { Text } = Typography;

// const SEVERITY_CONFIG: Record<PolicySeverity, { tagColor: string; label: string }> = {
//   block: { tagColor: "red", label: "Block" },
//   critical: { tagColor: "orange", label: "Critical" },
//   warn: { tagColor: "gold", label: "Warn" },
//   suggest: { tagColor: "blue", label: "Suggest" },
// };

// type Props = {
//   isOpen: boolean;
//   isAnalyzing: boolean;
//   auditResult: AuditResult | null | undefined;
//   isFixing: boolean;
//   fixResult: FixResult | null | undefined;
//   selected: Set<string>;
//   onToggle: (key: string) => void;
//   onFix: () => void;
//   onDiscardFix: () => void;
//   /** Called with the accepted subject + body. Parent is responsible for closing via audit.close(). */
//   onAcceptFix: (subject: string, body: string) => void;
//   onClose: () => void;
// };

// function AuditSkeleton() {
//   return (
//     <div className="flex flex-col gap-2 px-4 pt-3 pb-4">
//       <div className="flex items-center gap-2 mb-1">
//         <TbLoader2 size={13} className="animate-spin text-purple-500 shrink-0" />
//         <Text type="secondary" className="!text-xs">
//           Checking your email against policies…
//         </Text>
//       </div>

//       {[75, 60, 82, 55].map((w, i) => (
//         <div key={i} className="flex items-center gap-2.5 px-2.5 py-2 rounded-lg border border-gray-100 bg-gray-50">
//           {/* checkbox placeholder */}
//           <div className="size-3.5 rounded bg-gray-200 shrink-0" style={{ animationDelay: `${i * 80}ms` }} />
//           {/* icon circle */}
//           <div
//             className="size-4 rounded-full bg-gray-200 shrink-0 animate-pulse"
//             style={{ animationDelay: `${i * 80}ms` }}
//           />
//           {/* rule name */}
//           <div
//             className="h-2.5 rounded bg-gray-200 animate-pulse"
//             style={{ width: `${w}%`, animationDelay: `${i * 80 + 50}ms` }}
//           />
//           {/* severity tag */}
//           <div
//             className="h-4 w-10 rounded bg-gray-200 animate-pulse ml-auto shrink-0"
//             style={{ animationDelay: `${i * 80 + 100}ms` }}
//           />
//         </div>
//       ))}
//     </div>
//   );
// }

// function FixSkeleton() {
//   return (
//     <div className="flex flex-col items-center justify-center gap-2 py-6">
//       <TbLoader2 size={18} className="animate-spin text-purple-400" />
//       <Text type="secondary" className="!text-xs">
//         Generating rewrite…
//       </Text>
//     </div>
//   );
// }

// function ViolationRow({ rule, checked, onToggle }: { rule: AuditRule; checked: boolean; onToggle: () => void }) {
//   return (
//     <div
//       onClick={onToggle}
//       className={[
//         "flex items-center gap-2.5 px-2.5 py-2 rounded-lg border cursor-pointer transition-colors",
//         checked
//           ? "bg-red-50 border-red-200 hover:bg-red-100"
//           : "bg-gray-50 border-gray-100 opacity-60 hover:opacity-80",
//       ].join(" ")}
//     >
//       <input
//         type="checkbox"
//         checked={checked}
//         readOnly
//         onClick={(e) => e.stopPropagation()}
//         className="size-3.5 accent-purple-600 shrink-0 cursor-pointer"
//       />

//       {/* <div className="flex items-center justify-center size-4 rounded-full bg-red-100 border border-red-300 shrink-0">
//         <TbX size={9} className="text-red-600" strokeWidth={3} />
//       </div> */}

//       <Text className="text-xs flex-1 min-w-0 truncate">{rule.name}</Text>

//       {/* <Tag color={cfg.tagColor} className="!text-[10px] !leading-4 !px-1.5 !py-0 !m-0 shrink-0 capitalize">
//         {cfg.label}
//       </Tag> */}
//     </div>
//   );
// }

// function PassingRow({ rule }: { rule: AuditRule }) {
//   const cfg = SEVERITY_CONFIG[rule.severity];

//   return (
//     <div className="flex items-center gap-2.5 px-2.5 py-2 rounded-lg border border-gray-100 bg-gray-50 ">
//       {/* spacer to align with violation checkbox */}
//       {/* <div className="size-3.5 shrink-0" /> */}

//       <div className="flex items-center justify-center size-4 rounded-full bg-green-100 border border-green-300 shrink-0">
//         <TbCheck size={9} className="text-green-600" strokeWidth={3} />
//       </div>

//       <Text type="secondary" className="text-xs flex-1 min-w-0 truncate">
//         {rule.name}
//       </Text>

//       {/* <Tag color={cfg.tagColor} className="!text-[10px] !leading-4 !px-1.5 !py-0 !m-0 shrink-0 capitalize opacity-50">
//         {cfg.label}
//       </Tag> */}
//     </div>
//   );
// }

// function ResultsView({
//   result,
//   selected,
//   onToggle,
//   onFix,
//   isFixing,
//   onClose,
// }: {
//   result: AuditResult;
//   selected: Set<string>;
//   onToggle: (key: string) => void;
//   onFix: () => void;
//   isFixing: boolean;
//   onClose: () => void;
// }) {
//   const violationCount = result.invalid_rules.length;

//   return (
//     <div className="flex flex-col gap-2 px-4 pt-3 pb-4">
//       {/* Header row */}
//       <div className="flex items-center justify-between mb-1">
//         <div className="flex items-center gap-1.5">
//           <TbShieldCheck size={13} className="text-purple-500 shrink-0" />
//           <Text className="text-xs !font-semibold">Audit results</Text>
//           <span
//             className={[
//               "text-[10px] font-semibold rounded-full px-1.5 py-px leading-4",
//               violationCount > 0 ? "bg-red-100 text-red-700" : "bg-green-100 text-green-700",
//             ].join(" ")}
//           >
//             {violationCount > 0 ? `${violationCount} issue${violationCount > 1 ? "s" : ""}` : "All clear"}
//           </span>
//         </div>

//         <div className="flex items-center gap-2">
//           {violationCount > 0 && (
//             <Button
//               size="small"
//               loading={isFixing}
//               disabled={selected.size === 0}
//               onClick={onFix}
//               icon={!isFixing ? <TbSparkles size={12} /> : null}
//               className="!text-[11px] !h-auto !py-1 !px-2.5"
//               style={{ background: "#f5f3ff", color: "#6d28d9", borderColor: "#c4b5fd" }}
//             >
//               Fix selected{selected.size > 0 ? ` (${selected.size})` : ""}
//             </Button>
//           )}
//           {/* <Button size="small" danger onClick={onClose} icon={<TbX size={13} />} className="">
//             Close
//           </Button> */}
//         </div>
//       </div>

//       {/* Violations (checkable) */}
//       <div className="flex flex-col items-start  gap-4">
//         {result.invalid_rules.map((rule) => (
//           <ViolationRow
//             key={rule.key}
//             rule={rule}
//             checked={selected.has(rule.key)}
//             onToggle={() => onToggle(rule.key)}
//           />
//         ))}
//       </div>

//       {/* Passing rules (display only) */}
//       <div className="flex flex-col items-start gap-4">
//         {result.valid_rules.map((rule) => (
//           <PassingRow key={rule.key} rule={rule} />
//         ))}
//       </div>
//     </div>
//   );
// }

// function FixPreview({ fix, onAccept, onDiscard }: { fix: FixResult; onAccept: () => void; onDiscard: () => void }) {
//   return (
//     <div className="flex flex-col gap-2.5 px-4 pt-3 pb-4">
//       {/* Header row */}
//       <div className="flex items-center justify-between">
//         <div className="flex items-center gap-1.5">
//           <TbSparkles size={13} className="text-purple-500 shrink-0" />
//           <Text className="text-xs !font-semibold">Suggested rewrite</Text>
//           <span className="text-[10px] font-medium bg-blue-50 text-blue-700 rounded-full px-1.5 py-px leading-4">
//             Preview
//           </span>
//         </div>

//         <div className="flex items-center gap-1.5">
//           <Button size="small" onClick={onDiscard} className="!text-[11px] !h-auto !py-1 !px-2.5">
//             Discard
//           </Button>
//           <Button
//             size="small"
//             type="primary"
//             onClick={onAccept}
//             icon={<TbCheck size={12} />}
//             className="!text-[11px] !h-auto !py-1 !px-2.5"
//           >
//             Accept
//           </Button>
//         </div>
//       </div>

//       {/* Subject preview */}
//       <div className="rounded-lg border border-blue-100 bg-blue-50 px-3 py-2 shrink-0">
//         <Text className="block !text-[10px] text-blue-400 uppercase tracking-wide mb-0.5">Subject</Text>
//         <Text className="text-xs">{fix.subject}</Text>
//       </div>

//       {/* Body preview — scrollable if long */}
//       <div className="rounded-lg border border-blue-100 bg-blue-50 px-3 py-2.5 max-h-28 overflow-y-auto">
//         <Text className="block !text-[10px] text-blue-400 uppercase tracking-wide mb-0.5">Body</Text>
//         <Text className="text-xs leading-5">{fix.body}</Text>
//       </div>
//     </div>
//   );
// }

// export default function EmailAuditPanel({
//   isOpen,
//   isAnalyzing,
//   auditResult,
//   isFixing,
//   fixResult,
//   selected,
//   onToggle,
//   onFix,
//   onDiscardFix,
//   onAcceptFix,
//   onClose,
// }: Props) {
//   // Which sub-view to render — derived, not stored
//   const showAuditSkeleton = isAnalyzing;
//   const showResults = !isAnalyzing && !!auditResult && !isFixing && !fixResult;
//   const showFixSkeleton = isFixing;
//   const showFixPreview = !isFixing && !!fixResult;

//   return (
//     <Modal
//       open={isOpen}
//       onCancel={onClose}
//       footer={null}
//       width={520}
//       centered
//       destroyOnClose
//       title={
//         isAnalyzing
//           ? "Checking policies…"
//           : isFixing
//             ? "Generating rewrite…"
//             : fixResult
//               ? "Suggested rewrite"
//               : "Audit results"
//       }
//     >
//       {showAuditSkeleton && <AuditSkeleton />}

//       {showResults && (
//         <ResultsView
//           result={auditResult!}
//           selected={selected}
//           onToggle={onToggle}
//           onFix={onFix}
//           isFixing={false}
//           onClose={onClose}
//         />
//       )}

//       {showFixSkeleton && <FixSkeleton />}

//       {showFixPreview && (
//         <FixPreview
//           fix={fixResult!}
//           onAccept={() => onAcceptFix(fixResult!.subject, fixResult!.body)}
//           onDiscard={onDiscardFix}
//         />
//       )}
//     </Modal>
//   );
// }

// import { useState } from "react";
// import { Button, Modal, Tag, Typography } from "antd";
// import { TbCheck, TbChevronDown, TbLoader2, TbShieldCheck, TbSparkles, TbX } from "react-icons/tb";
// import type { AuditResult, AuditRule, FixResult } from "hooks/useEmailAudit";
// import { PolicySeverity } from "dtos/smart-negotiation.dto";

// const { Text } = Typography;

// // ── Config ────────────────────────────────────────────────────────────────────

// const SEVERITY_CONFIG: Record<PolicySeverity, { tagColor: string; label: string; dot: string }> = {
//   block: { tagColor: "red", label: "Block", dot: "bg-red-500" },
//   critical: { tagColor: "orange", label: "Critical", dot: "bg-orange-500" },
//   warn: { tagColor: "gold", label: "Warn", dot: "bg-amber-400" },
//   suggest: { tagColor: "blue", label: "Suggest", dot: "bg-blue-400" },
// };

// // ── Props ─────────────────────────────────────────────────────────────────────

// type Props = {
//   isOpen: boolean;
//   isAnalyzing: boolean;
//   auditResult: AuditResult | null | undefined;
//   isFixing: boolean;
//   fixResult: FixResult | null | undefined;
//   selected: Set<string>;
//   onToggle: (key: string) => void;
//   onFix: () => void;
//   onDiscardFix: () => void;
//   onAcceptFix: (subject: string, body: string) => void;
//   onClose: () => void;
// };

// // ── Skeletons ─────────────────────────────────────────────────────────────────

// function AuditSkeleton() {
//   return (
//     <div className="flex flex-col gap-2 py-2">
//       <div className="flex items-center gap-2 mb-2">
//         <TbLoader2 size={13} className="animate-spin text-purple-500 shrink-0" />
//         <Text type="secondary" className="!text-xs">
//           Checking your email against policies…
//         </Text>
//       </div>

//       {/* Skeleton section block */}
//       <div className="border border-gray-200 rounded-lg overflow-hidden">
//         {[75, 60, 82, 55].map((w, i) => (
//           <div key={i} className={`flex items-center gap-3 px-3 py-3 ${i !== 3 ? "border-b border-gray-100" : ""}`}>
//             <div
//               className="size-3.5 rounded bg-gray-200 animate-pulse shrink-0"
//               style={{ animationDelay: `${i * 80}ms` }}
//             />
//             <div
//               className="size-2 rounded-full bg-gray-200 animate-pulse shrink-0"
//               style={{ animationDelay: `${i * 80}ms` }}
//             />
//             <div className="flex-1 flex flex-col gap-1.5">
//               <div
//                 className="h-2.5 rounded bg-gray-200 animate-pulse"
//                 style={{ width: `${w}%`, animationDelay: `${i * 80 + 50}ms` }}
//               />
//               <div
//                 className="h-2 rounded bg-gray-100 animate-pulse"
//                 style={{ width: `${w - 20}%`, animationDelay: `${i * 80 + 80}ms` }}
//               />
//             </div>
//             <div
//               className="h-4 w-12 rounded bg-gray-200 animate-pulse shrink-0"
//               style={{ animationDelay: `${i * 80 + 100}ms` }}
//             />
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// function FixSkeleton() {
//   return (
//     <div className="flex flex-col items-center justify-center gap-2 py-8">
//       <TbLoader2 size={20} className="animate-spin text-purple-400" />
//       <Text type="secondary" className="!text-xs">
//         Generating rewrite…
//       </Text>
//     </div>
//   );
// }

// // ── Rule rows ─────────────────────────────────────────────────────────────────

// function ViolationRow({ rule, checked, onToggle }: { rule: AuditRule; checked: boolean; onToggle: () => void }) {
//   const cfg = SEVERITY_CONFIG[rule.severity];

//   return (
//     <div
//       onClick={onToggle}
//       className={[
//         "flex items-start gap-3 px-3 py-3 cursor-pointer transition-colors",
//         checked ? "bg-red-50 hover:bg-red-100" : "bg-white hover:bg-gray-50 opacity-60",
//       ].join(" ")}
//     >
//       {/* Checkbox */}
//       <input
//         type="checkbox"
//         checked={checked}
//         readOnly
//         onClick={(e) => e.stopPropagation()}
//         className="mt-0.5 size-3.5 accent-purple-600 shrink-0 cursor-pointer"
//       />

//       {/* Severity dot — acts as the status indicator */}
//       <div className={`mt-1.5 size-2 rounded-full shrink-0 ${cfg.dot}`} />

//       {/* Name + hint */}
//       <div className="flex-1 min-w-0">
//         <Text className="!text-[13px] !font-medium block leading-5">{rule.name}</Text>
//         {rule.hint && (
//           <Text type="secondary" className="!text-xs leading-5 mt-0.5 block">
//             {rule.hint}
//           </Text>
//         )}
//       </div>

//       {/* Severity tag */}
//       <Tag color={cfg.tagColor} className="!text-[10px] !leading-4 !px-1.5 !py-0 !m-0 shrink-0 capitalize mt-0.5">
//         {cfg.label}
//       </Tag>
//     </div>
//   );
// }

// function PassingRow({ rule }: { rule: AuditRule }) {
//   const cfg = SEVERITY_CONFIG[rule.severity];

//   return (
//     <div className="flex items-center gap-3 px-3 py-2.5">
//       {/* Check icon — mirrors checkbox width for alignment */}
//       <TbCheck size={14} className="text-green-500 shrink-0" />

//       <Text type="secondary" className="!text-[13px] flex-1 min-w-0 truncate">
//         {rule.name}
//       </Text>

//       <Tag color={cfg.tagColor} className="!text-[10px] !leading-4 !px-1.5 !py-0 !m-0 shrink-0 capitalize opacity-40">
//         {cfg.label}
//       </Tag>
//     </div>
//   );
// }

// // ── Results view ──────────────────────────────────────────────────────────────

// function ResultsView({
//   result,
//   selected,
//   onToggle,
//   onFix,
//   isFixing,
// }: {
//   result: AuditResult;
//   selected: Set<string>;
//   onToggle: (key: string) => void;
//   onFix: () => void;
//   isFixing: boolean;
// }) {
//   const [showPassed, setShowPassed] = useState(false);

//   // NOTE: invalid_rules = violations, valid_rules = passing (per your existing mapping)
//   const violations = result.invalid_rules;
//   const passing = result.valid_rules;
//   const violationCount = violations.length;

//   return (
//     <div className="flex flex-col gap-3 py-1">
//       {/* ── Summary header ─────────────────────────────────────────────── */}
//       <div className="flex items-center justify-between">
//         <div className="flex items-center gap-2">
//           {violationCount > 0 ? (
//             <>
//               <div className="flex items-center justify-center size-5 rounded-full bg-red-100 shrink-0">
//                 <TbX size={11} className="text-red-600" strokeWidth={2.5} />
//               </div>
//               <Text className="!text-[13px] !font-semibold">
//                 {violationCount} issue{violationCount > 1 ? "s" : ""} found
//               </Text>
//             </>
//           ) : (
//             <>
//               <div className="flex items-center justify-center size-5 rounded-full bg-green-100 shrink-0">
//                 <TbCheck size={11} className="text-green-600" strokeWidth={2.5} />
//               </div>
//               <Text className="!text-[13px] !font-semibold">All checks passed</Text>
//             </>
//           )}
//         </div>

//         {violationCount > 0 && (
//           <Button
//             size="small"
//             loading={isFixing}
//             disabled={selected.size === 0}
//             onClick={onFix}
//             icon={!isFixing ? <TbSparkles size={12} /> : null}
//             className="!text-[11px] !h-auto !py-1 !px-2.5"
//             style={{ background: "#f5f3ff", color: "#6d28d9", borderColor: "#c4b5fd" }}
//           >
//             Fix selected{selected.size > 0 ? ` (${selected.size})` : ""}
//           </Button>
//         )}
//       </div>

//       {/* ── Violations section ─────────────────────────────────────────── */}
//       {violationCount > 0 && (
//         <div className="border border-red-100 rounded-lg overflow-hidden divide-y divide-red-100">
//           {violations.map((rule) => (
//             <ViolationRow
//               key={rule.key}
//               rule={rule}
//               checked={selected.has(rule.key)}
//               onToggle={() => onToggle(rule.key)}
//             />
//           ))}
//         </div>
//       )}

//       {/* ── Passed section — collapsible ───────────────────────────────── */}
//       {passing.length > 0 && (
//         <div className="border border-gray-200 rounded-lg overflow-hidden">
//           {/* Collapse toggle header — mirrors GitHub's "Hide all checks" */}
//           <button
//             type="button"
//             onClick={() => setShowPassed((p) => !p)}
//             className="w-full flex items-center justify-between px-3 py-2.5 bg-gray-50 hover:bg-gray-100 transition-colors text-left"
//           >
//             <div className="flex items-center gap-2">
//               <TbShieldCheck size={13} className="text-green-500 shrink-0" />
//               <Text className="!text-xs !font-medium text-gray-600">
//                 {passing.length} check{passing.length > 1 ? "s" : ""} passed
//               </Text>
//             </div>
//             <TbChevronDown
//               size={13}
//               className={`text-gray-400 transition-transform duration-200 ${showPassed ? "rotate-180" : ""}`}
//             />
//           </button>

//           {showPassed && (
//             <div className="divide-y divide-gray-100">
//               {passing.map((rule) => (
//                 <PassingRow key={rule.key} rule={rule} />
//               ))}
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }

// // ── Fix preview ───────────────────────────────────────────────────────────────

// function FixPreview({ fix, onAccept, onDiscard }: { fix: FixResult; onAccept: () => void; onDiscard: () => void }) {
//   return (
//     <div className="flex flex-col gap-3 py-1">
//       <div className="rounded-lg border border-blue-100 bg-blue-50 px-3 py-2.5 shrink-0">
//         <Text className="block !text-[10px] text-blue-400 uppercase tracking-wide mb-1">Subject</Text>
//         <Text className="text-[13px] font-medium">{fix.subject}</Text>
//       </div>

//       <div className="rounded-lg border border-blue-100 bg-blue-50 px-3 py-2.5 max-h-40 overflow-y-auto">
//         <Text className="block !text-[10px] text-blue-400 uppercase tracking-wide mb-1">Body</Text>
//         <Text className="text-[13px] leading-6">{fix.body}</Text>
//       </div>

//       <div className="flex items-center justify-end gap-2 pt-1">
//         <Button size="small" onClick={onDiscard} className="!text-[12px]">
//           Discard
//         </Button>
//         <Button size="small" type="primary" onClick={onAccept} icon={<TbCheck size={13} />} className="!text-[12px]">
//           Accept & replace
//         </Button>
//       </div>
//     </div>
//   );
// }

// // ── Main component ────────────────────────────────────────────────────────────

// export default function EmailAuditPanel({
//   isOpen,
//   isAnalyzing,
//   auditResult,
//   isFixing,
//   fixResult,
//   selected,
//   onToggle,
//   onFix,
//   onDiscardFix,
//   onAcceptFix,
//   onClose,
// }: Props) {
//   const showAuditSkeleton = isAnalyzing;
//   const showResults = !isAnalyzing && !!auditResult && !isFixing && !fixResult;
//   const showFixSkeleton = isFixing;
//   const showFixPreview = !isFixing && !!fixResult;

//   return (
//     <Modal
//       open={isOpen}
//       onCancel={onClose}
//       footer={null}
//       width={520}
//       centered
//       destroyOnClose
//       title={
//         isAnalyzing
//           ? "Checking policies…"
//           : isFixing
//             ? "Generating rewrite…"
//             : fixResult
//               ? "Suggested rewrite"
//               : "Audit results"
//       }
//     >
//       {showAuditSkeleton && <AuditSkeleton />}

//       {showResults && (
//         <ResultsView result={auditResult!} selected={selected} onToggle={onToggle} onFix={onFix} isFixing={false} />
//       )}

//       {showFixSkeleton && <FixSkeleton />}

//       {showFixPreview && (
//         <FixPreview
//           fix={fixResult!}
//           onAccept={() => onAcceptFix(fixResult!.subject, fixResult!.body)}
//           onDiscard={onDiscardFix}
//         />
//       )}
//     </Modal>
//   );
// }

import { Button, Collapse, Modal, Tooltip, Typography } from "antd";
import { TbCheck, TbChevronDownLeft, TbHelpCircle, TbLoader2, TbShieldCheck, TbSparkles, TbX } from "react-icons/tb";
import type { AuditResult, AuditRule, FixResult } from "hooks/useEmailAudit";
import { PolicySeverity } from "dtos/smart-negotiation.dto";
import { IoIosArrowDown } from "react-icons/io";

const { Text } = Typography;

// ── Config ────────────────────────────────────────────────────────────────────

const SEVERITY_DOT: Record<PolicySeverity, string> = {
  block: "bg-red-500",
  critical: "bg-orange-500",
  warn: "bg-amber-400",
  suggest: "bg-blue-400",
};

// ── Props ─────────────────────────────────────────────────────────────────────

type Props = {
  isOpen: boolean;
  isAnalyzing: boolean;
  auditResult: AuditResult | null | undefined;
  isFixing: boolean;
  fixResult: FixResult | null | undefined;
  selected: Set<string>;
  onToggle: (key: string) => void;
  onFix: () => void;
  onDiscardFix: () => void;
  onAcceptFix: (subject: string, body: string) => void;
  onClose: () => void;
};

// ── Skeletons ─────────────────────────────────────────────────────────────────

function AuditSkeleton() {
  return (
    <div className="flex flex-col gap-3 py-1">
      <div className="flex items-center gap-2">
        <TbLoader2 size={13} className="animate-spin text-purple-500 shrink-0" />
        <Text type="secondary" className="!text-xs">
          Checking your email against policies…
        </Text>
      </div>

      <div className="border border-gray-200 rounded-lg overflow-hidden divide-y divide-gray-100">
        {[72, 58, 80, 50].map((w, i) => (
          <div key={i} className="flex items-center gap-3 px-3 py-3">
            <div className="size-3.5 rounded bg-gray-200 animate-pulse shrink-0" />
            <div className="size-2 rounded-full bg-gray-200 animate-pulse shrink-0" />
            <div
              className="h-2.5 rounded bg-gray-200 animate-pulse"
              style={{ width: `${w}%`, animationDelay: `${i * 80}ms` }}
            />
            <div
              className="ml-auto size-4 rounded bg-gray-100 animate-pulse shrink-0"
              style={{ animationDelay: `${i * 80 + 80}ms` }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

function FixSkeleton() {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-8">
      <TbLoader2 size={20} className="animate-spin text-purple-400" />
      <Text type="secondary" className="!text-xs">
        Generating rewrite…
      </Text>
    </div>
  );
}

// ── Rule rows ─────────────────────────────────────────────────────────────────

function ViolationRow({ rule, checked, onToggle }: { rule: AuditRule; checked: boolean; onToggle: () => void }) {
  return (
    <div
      onClick={onToggle}
      className="flex items-center gap-3 px-3 py-2.5 cursor-pointer hover:bg-gray-50 transition-colors"
    >
      <input
        type="checkbox"
        checked={checked}
        readOnly
        onClick={(e) => e.stopPropagation()}
        className="size-3.5 accent-purple-600 shrink-0 cursor-pointer"
      />

      {/* Severity dot — only color indicator, replaces the removed Tag */}
      <div className={`size-2 rounded-full shrink-0 ${SEVERITY_DOT[rule.severity]}`} />

      <Text className="!text-[13px] flex-1 min-w-0 truncate">{rule.name}</Text>

      {/* Hint — shown only on hover via Tooltip, never inline */}
      {rule.hint && (
        <Tooltip title={rule.hint} placement="left" className="max-w-xs">
          <TbHelpCircle
            size={14}
            className="text-gray-300 hover:text-gray-500 transition-colors shrink-0 cursor-help"
            onClick={(e) => e.stopPropagation()}
          />
        </Tooltip>
      )}
    </div>
  );
}

function PassingRow({ rule }: { rule: AuditRule }) {
  return (
    <div className="flex items-center gap-3 px-3 py-2.5">
      <TbCheck size={14} className="text-green-500 shrink-0" />
      <Text className="!text-[13px] flex-1 min-w-0 truncate">{rule.name}</Text>
    </div>
  );
}

// ── Results view ──────────────────────────────────────────────────────────────

function ResultsView({
  result,
  selected,
  onToggle,
  onFix,
  isFixing,
}: {
  result: AuditResult;
  selected: Set<string>;
  onToggle: (key: string) => void;
  onFix: () => void;
  isFixing: boolean;
}) {
  // NOTE: invalid_rules = violations, valid_rules = passing (per existing mapping)
  const violations = result.invalid_rules;
  const passing = result.valid_rules;
  const violationCount = violations.length;

  return (
    <div className="flex flex-col gap-3 py-1">
      {/* ── Summary header ─────────────────────────────────────────────── */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          {violationCount > 0 ? (
            <>
              <div className="flex items-center justify-center size-5 rounded-full bg-red-100 shrink-0">
                <TbX size={11} className="text-red-600" strokeWidth={2.5} />
              </div>
              <Text className="!text-[13px] !font-semibold">
                {violationCount} issue{violationCount > 1 ? "s" : ""} found
              </Text>
            </>
          ) : (
            <>
              <div className="flex items-center justify-center size-5 rounded-full bg-green-100 shrink-0">
                <TbCheck size={11} className="text-green-600" strokeWidth={2.5} />
              </div>
              <Text className="!text-[13px] !font-semibold">All checks passed</Text>
            </>
          )}
        </div>

        {violationCount > 0 && (
          <Button
            size="small"
            loading={isFixing}
            disabled={selected.size === 0}
            onClick={onFix}
            icon={!isFixing ? <TbSparkles size={12} /> : null}
            className="!text-[11px] !h-auto !py-1 !px-2.5"
            style={{ background: "#f5f3ff", color: "#6d28d9", borderColor: "#c4b5fd" }}
          >
            Fix selected{selected.size > 0 ? ` (${selected.size})` : ""}
          </Button>
        )}
      </div>

      {/* ── Violations list ────────────────────────────────────────────── */}
      {violationCount > 0 && (
        <div className="border border-gray-200 rounded-lg overflow-hidden divide-y divide-gray-100">
          {violations.map((rule) => (
            <ViolationRow
              key={rule.key}
              rule={rule}
              checked={selected.has(rule.key)}
              onToggle={() => onToggle(rule.key)}
            />
          ))}
        </div>
      )}

      {/* ── Passed — Ant Design Collapse ───────────────────────────────── */}
      {passing.length > 0 && (
        <Collapse
          ghost
          expandIcon={({ isActive }) => (
            <IoIosArrowDown
              style={{
                transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s ease",
              }}
            />
          )}
          size="small"
          className="!border !border-gray-200 !rounded-lg !overflow-hidden"
          items={[
            {
              key: "passed",
              label: (
                <div className="flex items-center gap-2 mt-0.5">
                  <TbShieldCheck size={13} className="text-green-500 shrink-0" />
                  <Text className="!text-xs !font-medium">
                    {passing.length} check{passing.length > 1 ? "s" : ""} passed
                  </Text>
                </div>
              ),
              children: (
                <div className="divide-y divide-gray-100 -mx-4 -my-3 border-t border-gray-100">
                  {passing.map((rule) => (
                    <PassingRow key={rule.key} rule={rule} />
                  ))}
                </div>
              ),
            },
          ]}
        />
      )}
    </div>
  );
}

// ── Fix preview ───────────────────────────────────────────────────────────────

function FixPreview({ fix, onAccept, onDiscard }: { fix: FixResult; onAccept: () => void; onDiscard: () => void }) {
  return (
    <div className="flex flex-col gap-3 py-1">
      <div className="rounded-lg border border-blue-100 bg-blue-50 px-3 py-2.5 shrink-0">
        <Text className="block !text-[10px] text-blue-400 uppercase tracking-wide mb-1">Subject</Text>
        <Text className="!text-[13px] !font-medium">{(fix as any)?.email?.subject || fix?.subject}</Text>
      </div>

      <div className="rounded-lg border border-blue-100 bg-blue-50 px-3 py-2.5 max-h-40 overflow-y-auto">
        <Text className="block !text-[10px] text-blue-400 uppercase tracking-wide mb-1">Body</Text>
        <Text className="!text-[13px] leading-6">{(fix as any)?.email?.body || fix?.body}</Text>
      </div>

      <div className="flex items-center justify-end gap-2 pt-1">
        <Button size="small" onClick={onDiscard} className="!text-[12px]">
          Discard
        </Button>
        <Button size="small" type="primary" onClick={onAccept} icon={<TbCheck size={13} />} className="!text-[12px]">
          Accept & replace
        </Button>
      </div>
    </div>
  );
}

// ── Main component ────────────────────────────────────────────────────────────

export default function EmailAuditPanel({
  isOpen,
  isAnalyzing,
  auditResult,
  isFixing,
  fixResult,
  selected,
  onToggle,
  onFix,
  onDiscardFix,
  onAcceptFix,
  onClose,
}: Props) {
  const showAuditSkeleton = isAnalyzing;
  const showResults = !isAnalyzing && !!auditResult && !isFixing && !fixResult;
  const showFixSkeleton = isFixing;
  const showFixPreview = !isFixing && !!fixResult;

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={520}
      centered
      destroyOnClose
      title={
        isAnalyzing
          ? "Checking policies…"
          : isFixing
            ? "Generating rewrite…"
            : fixResult
              ? "Suggested rewrite"
              : "Audit results"
      }
    >
      {showAuditSkeleton && <AuditSkeleton />}

      {showResults && (
        <ResultsView result={auditResult!} selected={selected} onToggle={onToggle} onFix={onFix} isFixing={false} />
      )}

      {showFixSkeleton && <FixSkeleton />}

      {showFixPreview && (
        <FixPreview
          fix={fixResult!}
          onAccept={() => onAcceptFix(fixResult!.subject, fixResult!.body)}
          onDiscard={onDiscardFix}
        />
      )}
    </Modal>
  );
}
